import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { DialogHeader } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

/**
 * El encabezado de las ventanas de Compite (rediseño del 15-oct): el dibujo en un
 * círculo y, al lado, el título y la explicación de siempre (`DialogTitle` y
 * `DialogDescription` los pone cada ventana, así el lector de pantalla sigue
 * anunciando lo mismo). La misma forma que los asistentes de reglas y estrategias.
 */
export function EncabezadoDeVentana({
  icono: Icono,
  tono = 'primario',
  className,
  children,
}: {
  icono: LucideIcon;
  tono?: 'primario' | 'alerta' | 'peligro';
  className?: string;
  children: ReactNode;
}) {
  return (
    <DialogHeader className={cn('flex-row items-start gap-3 space-y-0 text-left', className)}>
      <span
        aria-hidden="true"
        className={cn(
          'flex h-10 w-10 shrink-0 items-center justify-center rounded-full',
          tono === 'primario' && 'bg-primary/10 text-primary',
          tono === 'alerta' && 'bg-alerta-suave text-alerta',
          tono === 'peligro' && 'bg-destructive/10 text-destructive'
        )}
      >
        <Icono className="h-5 w-5" />
      </span>
      <div className="min-w-0 flex-1 space-y-1.5 pr-6">{children}</div>
    </DialogHeader>
  );
}

/**
 * El pie de las ventanas: una barra con los botones, pegada al borde de abajo
 * (la ventana trae `p-6`; la barra lo compensa y toma sus esquinas).
 */
export const PIE_DE_VENTANA =
  '-mx-6 -mb-6 mt-2 gap-2 rounded-b-[inherit] border-t bg-muted/30 px-6 py-3 sm:items-center';
